<template>
  <el-card shadow="never" class="active-card">
    <h4>活动概览</h4>
    <template v-if="result">
      <div class="list-box">
        <div class="item" v-for="(item, index) in (baseData.activityType !== 2 ? codeTableSum : dataTypeSumSS)" :key="item.code">
          <div :class="['top', 'top'+index]">
            <el-tooltip class="item" effect="light" :content="item.tip" placement="right">
              <span class="title">{{item.name}} <i class="el-icon-question"></i></span>
            </el-tooltip>
            <p>
              <span class="data">{{handleData(item.code,result[item.code].activityData)}}</span>
              <span class="yuan">{{handleUnit(item.code)}}</span>
            </p>
          </div>
          <div class="bottom" v-if="baseData.timeType!==0">
            <p>
              <span class="label">{{compareLabel.lastaDay}}</span>
              <span class="per" :style="{color: getColor(result[item.code].lastPeriodPercentage)}">
                {{handleNubber(result[item.code].lastPeriodPercentage)}}
                <span v-show="result[item.code].lastPeriodPercentage!==null">%</span>
              </span>
            </p>
            <p>
              <span class="label">{{compareLabel.lastWeek}}</span>
              <span class="per" :style="{color: getColor(result[item.code].lastSamePeriodPercentage)}">
                {{handleNubber(result[item.code].lastSamePeriodPercentage)}}
                <span v-show="result[item.code].lastSamePeriodPercentage!==null">%</span>
              </span>
            </p>
          </div>
        </div>
      </div>
      <div class="detail-box" :style="{height:showDetail?(baseData.timeType===0?'270px':'400px'):'0'}" v-if="baseData.activityType !== 2 && data">
        <div class="item item1" v-for="i of 4" :key="i">
          <div class="active" v-for="(j, index) in (baseData.activityType === 1 ? codeTable : codeTableXsms)[i-1]" :key="index" :style="j.style">
            <el-tooltip style="display:inline" effect="light" :content="j.tip" placement="right">
              <p class="title">{{j.name}} <i class="el-icon-question"></i></p>
            </el-tooltip>
            <p class="data-box">
              <span class="data">{{handleData(j.code, data[j.code].activityData)}}</span>
              <span class="unit"> {{handleUnit(j.code)}}</span>
            </p>
            <template v-if="baseData.timeType!==0">
              <p style="margin:8px 4px 0 0">
                <span class="label">{{compareLabel.lastaDay}}</span>
                <span class="per" :style="{color: getColor(data[j.code].lastPeriodPercentage)}">
                  {{handleNubber(data[j.code].lastPeriodPercentage)}}
                  <span v-show="data[j.code].lastPeriodPercentage!== null">%</span>
                </span>
              </p>
              <p>
                <span class="label">{{compareLabel.lastWeek}}</span>
                <span class="per" :style="{color: getColor(data[j.code].lastSamePeriodPercentage)}">
                  {{handleNubber(data[j.code].lastSamePeriodPercentage)}}
                  <span v-show="data[j.code].lastSamePeriodPercentage!== null">%</span>
                </span>
              </p>
            </template>
          </div>
        </div>
      </div>
      <div class="detail-box" :style="{height:(showDetail?(baseData.timeType===0?'100px':'140px'):'0')}" v-if="baseData.activityType === 2 && data">
        <div class="item item1" style="width:100%; justify-content:space-around;">
          <div class="active" style="width:auto" v-for="(j, index) in codeTableSS" :key="index">
            <el-tooltip  effect="light" :content="j.tip" placement="right">
              <p class="title">{{j.name}} <i class="el-icon-question"></i></p>
            </el-tooltip>
            <p class="data-box"><span class="data">{{handleData(j.code, data[j.code].activityData)}}</span><span class="unit"> {{handleUnit(j.code)}}</span></p>
            <template v-if="baseData.timeType!==0">
              <p style="margin:8px 4px 0 0">
                <span class="label">{{compareLabel.lastaDay}}</span>
                <span class="per" :style="{color: getColor(data[j.code].lastPeriodPercentage)}">
                  {{handleNubber(data[j.code].lastPeriodPercentage)}}
                  <span v-show="data[j.code].lastPeriodPercentage!== null">%</span>
                </span>
              </p>
              <p>
                <span class="label">{{compareLabel.lastWeek}}</span>
                <span class="per" :style="{color: getColor(data[j.code].lastSamePeriodPercentage)}">
                  {{handleNubber(data[j.code].lastSamePeriodPercentage)}}
                  <span v-show="data[j.code].lastSamePeriodPercentage!== null">%</span>
                </span>
              </p>
            </template>
          </div>
        </div>
      </div>
      <p class="more" @click="changeShowDetail">{{showDetail?'收起更多数据':'展开更多数据'}} <i :class="showDetail?'el-icon-arrow-up':'el-icon-arrow-down'"></i></p>
    </template>
    <NoData v-else errTitle="暂无数据" setHeight="200px"></NoData>
  </el-card>
</template>
<script>
import { getOverview, getAllTarget } from "@/api/marketPromotion/activeData";
import { codelist, yuanUnit } from'../config'
import NoData from "@/components/base/no-data"
export default {
  props: {
    baseData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {NoData},
  data () {

    return {
      showDetail: false,
      ...codelist,
      result: null,
      data: null
    }
  },
  methods: {
    init () {
      let params = Object.assign({}, this.baseData)
      this.result = this.data = null
      this.getOverview(params)
      this.getAllTarget(params)
    },
    changeShowDetail () {
      let name = this.showDetail ? '营销推广-营销数据-收起更多数据' : '营销推广-营销数据-查看更多'
      this.$track.clickEvent(name, '1627641857')
      this.showDetail = !this.showDetail
    },
    async getOverview (params) {
      try {
        const { result } = await getOverview(params)
        this.result = result || null
      } catch (error) {
        console.log(error)
      }
    },
    async getAllTarget (params) {
      try {
        const { result } = await getAllTarget(params)
        this.data = result || null
      } catch (error) {
        console.log(error)
      }
    },
    handleData (code, data) {
      if(!data && data !== 0) return '-'
      if (this.handleUnit(code) === '%') {
        return Math.round(Number(data) * 10000)/100
      } else {
        return yuanUnit(data)
      }
    },
    handleUnit (code) {
      let unit
      switch (code) {
        case 'income':
        case 'costAmount':
        case 'realIncome':
        case 'oldUserRealIncome':
        case 'newUserRealIncome':
        case 'disActivityIncome':
          unit = '元'
          break;
        case 'userNum':
        case 'joinUserNum':
        case 'oldUserNum':
        case 'newUserNum':
        case 'recieveCouUserNum':
        case 'usedCouUserNum':
          unit = '人'
          break;
        case 'orderRate':
        case 'costRate':
        case 'orderFinishRate':
          unit = '%'
          break;
        case 'orderNum':
          unit = '笔'
          break;
        default:
          unit = '升'
          break;
      }
      return unit
    },
    handleNubber (num) {
      if(!num && num !== 0) return '-'
      let data = Math.round(Number(num) * 10000)/100
      return data > 0 ? '+' + data : data
    }
  },
  computed: {
    compareLabel () {
      if (this.baseData.dataType === 1 || this.baseData.dataType === -1) {
        return {
          lastaDay: '较前一日',
          lastWeek: '较上周期同一日'
        }
      } else {
        return {
          lastaDay: '较上一周期',
          lastWeek: '较上个同期'
        }
      }
    },
    getColor () {
      return (num) => {
        if (!num) return '#606266'
        if (num > 0) return '#E3223F'
        return '#40A81E'
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url('../mixin.less');
</style>